import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { FormControl, Validators, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AdministrarUsuariosService } from './../../../../services/administracion-usuarios/administrar-usuarios.service';
import { IResponseValidaContrasena, Validacion } from 'src/app/models/administracion-usuarios/administracion-usuarios.model';
import { Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { SnackbarMsmComponent } from '../registro-asegurado/registro-asegurado.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import ValidationRegistro from '../validators/registro.validators';
import { ActivarLoadingAction, DesactivarLoadingAction } from 'src/app/@store/actions';
import { BlockUI, NgBlockUI, BlockUIModule } from 'ng-block-ui';
import { BlockTemplateComponent } from 'src/app/@theme/@components';
import { INormaModelInput, IResponseModel } from 'src/app/models/seguros-atlas/atlas.model';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ValidadorDosFaComponent } from '../validador-dos-fa/validador-dos-fa.component';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { MatFormField, MatLabel, MatError, MatSuffix, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatSelect, MatOption } from '@angular/material/select';

export interface Pregunta {
  value: string;
  viewValue: string;
}

@Component({
    selector: 'app-registro-reasegurador',
    templateUrl: './registro-reasegurador.component.html',
    styleUrls: ['./registro-reasegurador.component.scss'],
    imports: [BlockUIModule, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatSuffix, MatIcon, MatTooltip, NgClass, MatIconButton, MatPrefix, MatButton, MatSelect, MatOption]
})
export class RegistroReaseguradorComponent implements OnInit {
  @BlockUI() blockUI?: NgBlockUI | any;
  public blockTemplate = BlockTemplateComponent;
  public template: string = 'corporativo';
  subsReduxUI = new Subscription();
  public store = inject(Store<AppState>);

  @Output() evento = new EventEmitter();
  imagen: string;
  loading = false;
  hide = true;
  todoFormulario: FormGroup;
  subsFormPassword$: Subscription;
  generaErrorPasswordForm = false;
  validandoPassword = false;
  verificarCorreo = "Verificar";
  verificarTelefono = "Verificar";
  validandoTelefono = false;
  validandoCorreo = false;
  emailAnterior: string;
  telefonoAnterior: string;
  bloqueoUsuario = false;
  validacionUsuario = '';
  actualizarUsuario: string = "false";
  errores: any = '';
  catPreguntas: [] = [];
  usuarioValido = { is: false, pending: false }

  colorBotones: string = "#ef3c46";

  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private adminService: AdministrarUsuariosService) { }

     ngOnDestroy(): void {
    this.subsReduxUI.unsubscribe();
  }
  
  ngOnInit() {
    // Suscripción a store redux UI
    this.subsReduxUI = this.store.select('ui').subscribe(data => {
      const loading = data?.block?.isLoading;
      const message = data?.block?.message || 'Cargando...';

      if (loading) {
        if (!this.blockUI.isActive) {
          this.blockUI.start(message);
        }
      } else {
        this.blockUI.stop();
      }
    });
    
    this.imagenAleatoria();
    this.instaciarFiltros();
    this.cataPreguntas();
    this.subsFormPassword$ = this.todoFormulario.get('Password').valueChanges
      .pipe(
        tap(contrasena => {
        this.validandoPassword = true;
      }),debounceTime(1000), distinctUntilChanged())
      .subscribe((pass: string) => {
        if (pass.length > 0) this.validarContrasena(pass);
        else this.reiniciarValidacionesContrasena();
      });

    this.todoFormulario.get('Usuario')?.valueChanges.pipe(
      tap(() => {
        this.validacionUsuario = '';
        this.usuarioValido.pending = true;
        this.usuarioValido.is = false;
      }),
      debounceTime(1000),
      distinctUntilChanged()
    ).subscribe((usuario: string) => {
      const control = this.todoFormulario.get('Usuario');
      const valorUsuario = `${usuario || ''}`;

      if (valorUsuario.length === 0) {
        this.usuarioValido.pending = false;
        this.usuarioValido.is = false;
        return;
      }

      if (control?.hasError('pattern')) {
        this.validacionUsuario = 'El campo debe ser alfanumérico.';
        this.usuarioValido.pending = false;
        this.usuarioValido.is = false;
        return;
      }

      this.validarUsuario(valorUsuario);

      if (!this.contrasenaVacia) {
        this.validarContrasena(this.todoFormulario.get('Password')?.value);
      }
    });
    this.todoFormulario.get('Email').valueChanges.
      pipe(distinctUntilChanged()).subscribe((nuevoEmail: string) => {
        if (this.validandoCorreo && this.todoFormulario.get('Email').value != this.emailAnterior)
          this.solicitaConfirmacionEmail(nuevoEmail);
        else
          this.emailAnterior = this.todoFormulario.get('Email').value;
      });

    this.todoFormulario.get('Telefono').valueChanges.
      pipe(distinctUntilChanged()).subscribe((nuevoTelefono: string) => {
        if (this.validandoTelefono && this.todoFormulario.get('Telefono').value != this.telefonoAnterior)
          this.solicitaConfirmacionTelefono(nuevoTelefono);
        else
          this.telefonoAnterior = this.todoFormulario.get('Telefono').value;
      });
  }

  solicitaConfirmacionEmail(nuevoEmail: string) {
    Swal.fire({
      title: 'Si cambias el email tendras que validarlo nuevamente',
      text: "¿Deseas cambiar el email?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cambiar',
      cancelButtonText: 'No, mantener anterior',
      cancelButtonColor: this.colorBotones,
      confirmButtonColor: this.colorBotones,
    }).then((result) => {
      if (result.isConfirmed) {
        this.emailAnterior = nuevoEmail;
        this.validandoCorreo = false;
      }
      this.todoFormulario.get('Email').setValue(this.emailAnterior);
    });
  }

  solicitaConfirmacionTelefono(nuevoTelefono: string) {
    Swal.fire({
      title: 'Si cambias el telefono tendras que validarlo nuevamente',
      text: "¿Deseas cambiar el telefono?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cambiar',
      cancelButtonText: 'No, mantener anterior',
      cancelButtonColor: this.colorBotones,
      confirmButtonColor: this.colorBotones,
    }).then((result) => {
      if (result.isConfirmed) {
        this.telefonoAnterior = nuevoTelefono;
        this.validandoTelefono = false;
      }
      this.todoFormulario.get('Telefono').setValue(this.telefonoAnterior);
    });
  }


  cataPreguntas() {
    this.store.dispatch(ActivarLoadingAction());
    this.authService.catalogoPreguntas().subscribe(resp => {
      this.store.dispatch(DesactivarLoadingAction());
      this.catPreguntas = Object.assign(resp);
    }, (err) =>{
      this.store.dispatch(DesactivarLoadingAction());
    });
  }

  registrar() {
    if (!this.validandoTelefono) {
      this.abrirSwalAlertAviso('error', 'Error al registrar', "El Número telefónico no esta validado", 'Aceptar', null);
      return;
    }
    if (!this.validandoCorreo) {
      this.abrirSwalAlertAviso('error', 'Error al registrar', "El Email no esta validado", 'Aceptar', null);
      return;
    }

    if (this.generaErrorPasswordForm) return this.abrirSnackBar('La contraseña de tener un formato correcto', `Contraseña`, 'exitoSnackbar');
    this.store.dispatch(ActivarLoadingAction());
    this.todoFormulario.get('ValidarUsuario').setValue(this.actualizarUsuario);
    this.authService.registrarReasegurador(this.todoFormulario.getRawValue()).subscribe(resp => {
      this.store.dispatch(DesactivarLoadingAction());
      this.abrirSwalAlertAviso('success', 'Usuario registrado', 'El reasegurador ' + this.todoFormulario.get('Usuario').value + ' Se registro exitosamente', 'Aceptar', null);
      this.regresar();
    }, (err) => {
      this.store.dispatch(DesactivarLoadingAction());
      this.errores = '';
      if (err?.error?.Message) this.errores = err.error.Message;
      if (err?.error && Array.isArray(err?.error)) {
        err.error.forEach(element => {
          this.errores = `${this.errores}${element.Exception} <br>`
        });
      }
      this.abrirSwalAlertAviso('error', 'Error al registrar', this.errores, 'Aceptar', null);
    });
  }

  instaciarFiltros() {
    this.todoFormulario = new FormGroup({
      NIP: new FormControl('', Validators.required),
      Usuario: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9_]*$/), Validators.minLength(4), Validators.maxLength(8)]),
      Cuenta: new FormControl(null, Validators.required),

      Telefono: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{12}$'), Validators.minLength(12), Validators.maxLength(12)]),
      CodTelefono: new FormControl(null),
      Email: new FormControl(null, [Validators.required, Validators.email, Validators.pattern('[^@]+@[^@]+\.[a-zA-Z]{2,}$')]),
      CodEmail: new FormControl(null),
      Alias: new FormControl('', Validators.required),
      IdPregunta: new FormControl(0, Validators.required),
      Respuesta: new FormControl('', Validators.required),

      RFC: new FormControl('', [Validators.required,
      Validators.pattern("^([A-Za-zÑñ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Za-z0-9]{3})?$"),
      Validators.maxLength(13)
      ]),

      Nacionalidad: new FormControl('', Validators.required),
      RazonSocial: new FormControl('', Validators.required),

      Password: new FormControl(null, [Validators.required]),
      ConfirmaPassword: new FormControl(null, [Validators.required]),
      ValidarUsuario: new FormControl('false', [Validators.required]),
    }, {
      validators: ValidationRegistro.match('Password', 'ConfirmaPassword')
    });
  }

  imagenAleatoria() {
    this.imagen = `assets/img/${Math.floor((Math.random() * Math.floor(5)) + 1)}.jpg`;
    setTimeout(() => {
      this.imagenAleatoria();
    }, 30000);
  }
  regresar() {
    this.evento.emit(true);
  }

  validarContrasena(password: string) {
    if(this.contrasenaVacia) return this.reiniciarValidacionesContrasena();

    let msgError = '';
    
    const request = { password, usuario: this.todoFormulario.get("Usuario").value };
    this.adminService.postValidaContrasena(request).subscribe((resp: IResponseValidaContrasena) => {
      this.validandoPassword = false;
      if (resp?.datos.length > 0) {
        this.generaErrorPasswordForm = true;
        this.procesarErroresPassword(resp.datos);
        this.todoFormulario.get('Password')?.setErrors({
          formatoIncorrecto: true
        });
        document.getElementById('iconPass').style.color = '#8395a7';
      } else {
        this.generaErrorPasswordForm = false;
        const control = this.todoFormulario.get('Password');
        if (control?.hasError('formatoIncorrecto')) {
          delete control.errors!['formatoIncorrecto'];
          if (Object.keys(control.errors || {}).length === 0) {
            control.setErrors(null);
          }
        }
        document.getElementById('iconPass').style.color = '#10ac84';
      }
    }, error => {
      const err = error.error || [];
      if (!err.length) msgError = "Ups, se generó un error";
      err.forEach((element, index) => {
        if (element.Visible) msgError = index === 0 ? element.Exception : `${msgError} ${element.Exception}`;
        if (element.password) msgError = element.password[0];
      });

      this.reiniciarValidacionesContrasena();
      this.abrirSnackBar(msgError, `Contraseña`, 'errorSnackbar');
    });
  }

  procesarErroresPassword(array: Validacion[]) {
    let msgError = "";
    array.forEach((element) => {
      if (array.length === 1)
        msgError += `<li> ${element.Descripcion} </li>`;
      else
        msgError += `<li> ${element.Descripcion} </li> <br>`;
    });
    this.abrirSnackBar(msgError, `Contraseña`, 'exitoSnackbar');
  }

  abrirSnackBar(mensaje: string, titulo: string, clase: string) {
    this.snackBar.openFromComponent(SnackbarMsmComponent, {
      duration: 5000,
      panelClass: clase,
      data: {
        html: mensaje
      }
    })
  }

  desbloquearUsuario() {
    this.verificarCorreo = "Verificar";
    this.verificarTelefono = "Verificar";
    this.bloqueoUsuario = false;
    this.todoFormulario.get('Usuario').setValue('');
    this.validandoTelefono = false;
    this.validandoCorreo = false;
  }

  private limpiarErroresControl(control: any, errores: string[]): void {
    if (!control || !control.errors) {
      return;
    }

    errores.forEach(errorKey => {
      if (control.errors?.[errorKey]) {
        delete control.errors[errorKey];
      }
    });

    if (Object.keys(control.errors).length === 0) {
      control.setErrors(null);
      return;
    }

    control.setErrors(control.errors);
  }
  
  validarUsuario(usuario: string) {
    const control = this.todoFormulario.get('Usuario');
    const valorUsuario = `${usuario || ''}`;

    if (!control) {
      return;
    }

    if (!/^[a-zA-Z0-9_]*$/.test(valorUsuario)) {
      this.validacionUsuario = 'El campo debe ser alfanumérico.';
      this.usuarioValido.pending = false;
      this.usuarioValido.is = false;

      control.setErrors({
        ...(control.errors || {}),
        pattern: true
      });

      return;
    }

    if (valorUsuario.length < 4) {
      this.validacionUsuario = 'El nombre de usuario debe tener al menos 4 caracteres.';
      this.usuarioValido.pending = false;
      this.usuarioValido.is = false;

      control.setErrors({
        ...(control.errors || {}),
        minlengthCustom: true
      });

      return;
    }

    if (valorUsuario.length > 8) {
      this.validacionUsuario = 'El campo solo puede tener hasta 8 caracteres.';
      this.usuarioValido.pending = false;
      this.usuarioValido.is = false;

      control.setErrors({
        ...(control.errors || {}),
        maxlengthCustom: true
      });

      return;
    }

    this.authService.validaUsuario(valorUsuario).subscribe(x => {
      this.authService.validaUsuarioSisa(valorUsuario).subscribe(x => {
        this.usuarioValido.is = true;
        this.usuarioValido.pending = false;
        this.validacionUsuario = '';

        this.limpiarErroresControl(control, [
          'exists',
          'customError',
          'minlengthCustom',
          'maxlengthCustom',
          'pattern'
        ]);

        if (this.validandoCorreo || this.validandoTelefono) {
          this.actualizarUsuario = 'true';
        }
      }, error => {
        this.usuarioValido.is = false;
        this.usuarioValido.pending = false;
        this.validacionUsuario = 'La clave de usuario ya existe.';

        control.setErrors({
          ...(control.errors || {}),
          exists: true,
          customError: error?.error?.Exception || true
        });
      });

    }, error => {
      this.usuarioValido.is = false;
      this.usuarioValido.pending = false;
      this.validacionUsuario = error?.error?.Exception || 'Usuario inválido.';

      control.setErrors({
        ...(control.errors || {}),
        customError: this.validacionUsuario
      });
    });
  }
  obtenerErrores(field) {
    const control = this.todoFormulario.get(field);
    let error = '';
    error = control.hasError('required') ? 'El campo es obligatorio' :
      control.hasError('maxlength') ? 'El campo solo puede tener hasta 8 caracteres' :
        control.hasError('pattern') ? 'El campo debe ser alfanumérico (A-Z,a-z,0-9)' : ''
    return error;
  }
  ValidarTelefono() {

    if (!this.usuarioValido.is) {
      this.abrirSwalAlertAviso('error', 'Error al validar', "Debe ingresar un Usuario valido", 'Aceptar', null);
      return;
    }
    this.store.dispatch(ActivarLoadingAction());
    this.validandoTelefono = false;

    const norma: INormaModelInput = {
      NumNorma: 765,
      Parametro1: 1,
      Parametro2: 0,
      Parametro3: 0,
    };

    this.authService.obtenerNormaAtlas(norma).subscribe(
      (res: IResponseModel) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (res.Respuesta.Status == 1) {
          let component: ComponentType<any>;
          component = ValidadorDosFaComponent;
          const configModal: MatDialogConfig<any> = {
            data: { tipo: "Telefono", valor: this.todoFormulario.get('Telefono').value, usuario: this.todoFormulario.get('Usuario').value }
          };
          const dialogRef = this.dialog.open(component, configModal).afterClosed().subscribe(result => {
            if (result.TwoFactorCode != null && result.TwoFactorCode != "") {
              this.todoFormulario.get('CodTelefono').setValue(result.TwoFactorCode);
              this.validandoTelefono = true;
              if (this.validandoCorreo) {
                this.actualizarUsuario = "false";
              }
            } else {
              this.todoFormulario.get('CodTelefono').setValue("");
              this.validandoTelefono = false;

            }
          });
        } else {
          this.todoFormulario.get('CodTelefono').setValue("9000");
          this.validandoTelefono = true;
          if (this.validandoCorreo) {
            this.actualizarUsuario = "false";
          }
        }
      },
      (error) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.abrirSwalAlertAviso('error', 'Error al registrar', "Intenta solicitar tu código mas tarde", 'Aceptar', null);
        this.todoFormulario.get('CodTelefono').setValue("");
        this.validandoTelefono = false;
      }
    );
  }

  ValidarCorreo() {
    if (!this.usuarioValido.is) {
      this.abrirSwalAlertAviso('error', 'Error al validar', "Debe ingresar un Usuario valido", 'Aceptar', null);
      return;
    }
    this.store.dispatch(ActivarLoadingAction());
    this.validandoCorreo = false;

    const norma: INormaModelInput = {
      NumNorma: 763,
      Parametro1: 1,
      Parametro2: 0,
      Parametro3: 0,
    };

    this.authService.obtenerNormaAtlas(norma).subscribe(
      (res: IResponseModel) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (res.Respuesta.Status == 1) {
          let component: ComponentType<any>;
          component = ValidadorDosFaComponent;
          const configModal: MatDialogConfig<any> = {
            data: { tipo: "Correo Electronico", valor: this.todoFormulario.get('Email').value, usuario: this.todoFormulario.get('Usuario').value }
          };
          const dialogRef = this.dialog.open(component, configModal).afterClosed().subscribe(result => {

            if (result.TwoFactorCode != null && result.TwoFactorCode != "") {
              this.todoFormulario.get('CodEmail').setValue(result.TwoFactorCode);
              this.validandoCorreo = true;
              if (this.validandoTelefono) {
                this.actualizarUsuario = "false";
              }

            } else {
              this.todoFormulario.get('CodEmail').setValue("");
              this.validandoCorreo = false;

            }

          });
        } else {
          this.todoFormulario.get('CodEmail').setValue("9000");
          this.validandoCorreo = true;
          if (this.validandoTelefono) {
            this.actualizarUsuario = "false";
          }

        }
      },
      (error) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.abrirSwalAlertAviso('error', 'Error al registrar', "Intenta solicitar tu código mas tarde", 'Aceptar', null);
        this.todoFormulario.get('CodEmail').setValue("");
        this.validandoCorreo = false;

      }
    );

  }

    reiniciarValidacionesContrasena(){
      const control = this.todoFormulario.get('Password');
      
        this.generaErrorPasswordForm = false;
        document.getElementById('iconPass').style.color = '#8395a7';
        this.validandoPassword = false;
        if (control?.hasError('formatoIncorrecto')) {
            delete control.errors!['formatoIncorrecto'];
            if (Object.keys(control.errors || {}).length === 0) {
              control.setErrors(null);
            }
          }
    }
  
    abrirSwalAlertAviso(icono: string, titulo: string, texto: string, textoCon: string, textoCan: string){
      Swal.fire({
          icon: (icono === "success" ? 'success' : icono === "warning" ? 'warning' : 'error'),
          title: titulo,
          html: texto,
          confirmButtonText: textoCon,
          cancelButtonText: textoCan,
          showCancelButton: (textoCan ? true : false),
          cancelButtonColor: this.colorBotones,
          confirmButtonColor: this.colorBotones,
        });
    }

     get contrasenaVacia():boolean {
    if(this.todoFormulario.get("Password").value === null) return true;
    else if(this.todoFormulario.get("Password").value.trim() === "") return true;
    else return false;
    }
}